import React from 'react';
import Grid from '@material-ui/core/Grid';
import axios from 'axios';
import urlBase from '../../../url-base';
import CircularProgress from 'material-ui/CircularProgress';
import Paper from 'material-ui/Paper';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FloatingActionButton from 'material-ui/FloatingActionButton';


class DentalNews extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      listFiles: 'loading',
      listFilesName: ['01'],

      fileDeleteNow: '',
      modalDelete: false,
      modalDeleteOpen: false,
      modalDeleteLoading: false,

      modalOpen: false,
      btnDisableSaveFile1: false,
      btnDisableSaveFile2: true,
      modalSaveLoading: false
    };

    this.styles = {
      panel: {
        padding: 20
      },
      contentImg: {
        textAlign: 'center',
        padding: 15,
        height: 150,
        backgroundColor: '#ddd',
        display: 'table',
        width: '100.1%',
        color: '#505050'
      },
      img: {
        verticalAlign: 'middle',
        display: 'table-cell',
        width: '25%'
      },
      contentImgFooter: {
        height: 50,
        textAlign: 'center',
        display: 'table',
        width: '100%'
      },
      contentImgFooterP: {
        display: 'table-cell',
        verticalAlign: 'middle',
        fontFamily: 'Rubik',
        fontWeight: 400
      },
      contentImgFooterIconDel: {
        float: 'right',
        position: 'relative',
        padding: '3px 8px',
        cursor: 'pointer'
      },
      contentImgFooterIconDow: {
        float: 'right',
        position: 'relative',
        padding: '3px 8px',
        color: '#505050'
      },
      closeBtn: {
        float: 'right',
        width: 25,
        cursor: 'pointer',
        position: 'relative',
        bottom: 15,
        left: 5
      },
      modal: {
        width: '85%',
        maxWidth: 'none',
      }
    };
  }


  componentDidMount() {
    this.getFiles();
  }

  getFiles() {
    axios.get(urlBase.loopBack + 'Attachments/dental_news/files')
    .then((result) => {
      let state = this.state;
      state.listFiles = result.data;
      this.setState(state);
    })
    .catch(function () {
      let state = this.state;
      state.listFiles = 'error';
      this.setState(state);
    }.bind(this));
  }

  fileChange(typeDoc) {
    /*
    * @type pode ser: "upload"
    */

    let file = document.getElementById('doc_'+typeDoc).files[0];
    let ext = file.name.split('.').pop().toLowerCase();

    if (ext == 'pdf') {
      document.getElementById('name_file_pdf_'+typeDoc).style.display = 'inherit';
      document.getElementById('name_file_'+typeDoc).style.display = 'none';
    }
    else {
      document.getElementById('name_file_pdf_'+typeDoc).style.display = 'none';
      document.getElementById('name_file_'+typeDoc).style.display = 'inherit';
      document.getElementById('name_file_'+typeDoc).src = window.URL.createObjectURL(file);
    }

    if (document.getElementById('doc_upload').files[0] == undefined)
      this.setState({btnDisableSaveFile2: true});
    else
      this.setState({btnDisableSaveFile2: false});
  }

  handleModalDeleteOpen(nameFile) {
    let state = this.state;
    state.fileDeleteNow = nameFile;
    state.modalDeleteOpen = true;
    this.setState(state);
  }

  handleModalDeleteClose() {
    this.setState({modalDeleteOpen: false});
    this.getFiles();
  }

  sendDelete() {
    let state = this.state;
    state.modalDelete = true;
    state.modalDeleteLoading = true;
    this.setState(state);

    axios.delete(urlBase.loopBack + 'Attachments/dental_news/files/'+this.state.fileDeleteNow)
    .then(() => {
      let state = this.state;
      state.modalDelete = false;
      state.modalDeleteLoading = false;
      state.fileDeleteNow = '';
      this.setState(state);
      this.handleModalDeleteClose();
    })
    .catch(function (error) {
      alert('Erro ao deletar arquivo: ', error);
    }.bind(this));
  }

  addFile() {
    let state = this.state;
    state.modalOpen = true;
    this.setState(state);
  }

  handleModalClose() {
    let state = this.state;
    state.modalOpen = false;
    state.btnDisableSaveFile2 = true;
    this.setState(state);
    this.getFiles();
  }

  saveFile() {
    let state = this.state;
    state.btnDisableSaveFile1 = true;
    state.btnDisableSaveFile2 = true;
    state.modalSaveLoading = true;
    this.setState(state);

    let bodyFormData = new FormData();
    bodyFormData.append('file', document.getElementById('doc_upload').files[0]); 

    axios({
      method: 'post',
      url: urlBase.loopBack + 'Attachments/dental_news/upload',
      data: bodyFormData,
      config: { headers: {'Content-Type': 'multipart/form-data' }}
      })
    .then(() => {
      let state = this.state;
      state.btnDisableSaveFile1 = false;
      state.btnDisableSaveFile2 = false;
      state.modalSaveLoading = false;
      this.setState(state);
      this.handleModalClose();
    })
    .catch(function (error) {
      alert('Erro ao salvar arquivo: ', error);
    }.bind(this));
  }

  render() {
    return (
      <div>
        {
          this.state.listFiles == 'loading' ? (
        <Grid container spacing={24} alignContent="center">
          <Grid item xs={12} sm={12} md={12} lg={12} style={{marginTop: 50,textAlign: 'center'}}>
            <Paper style={this.styles.panel} zDepth={1}>
              <CircularProgress />
            </Paper>
          </Grid>
        </Grid>
          ) : (
            this.state.listFiles == 'error' ? (
        <Grid container spacing={24} alignContent="center">
          <Grid item xs={12} sm={12} md={12} lg={12} style={{marginTop: 50,textAlign: 'center'}}>
            <Paper style={this.styles.panel} zDepth={1}>
              <p style={{color: 'rgb(237, 65, 52)'}}>Problema encontrado ao buscar lista de arquivos.</p>
            </Paper>
          </Grid>
        </Grid>
            ) : (
              this.state.listFiles.length == 0 ? (
        <Grid container spacing={24} alignContent="center">
          <Grid item xs={12} sm={12} md={12} lg={12} style={{marginTop: 50,textAlign: 'center'}}>
            <Paper style={this.styles.panel} zDepth={1}>
              <p>Nenhum arquivo cadastrado.</p>
            </Paper>
          </Grid>
        </Grid>
              ) : (
        <Grid container spacing={24} alignContent="center">
                {this.state.listFiles.map((item, index) =>
          <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
            <Paper>
              <div>
                <a target="_blank" href={urlBase.loopBack+'Attachments/dental_news/download/'+item.name}>
                  <div style={this.styles.contentImg}>
                    {
                      item.name.toLowerCase().indexOf('.pdf') > 0 ? (
                    <i
                      style={this.styles.img}
                      className="far fa-file-pdf fa-6x"
                    >
                      &nbsp;
                    </i>
                      ) : (
                    <div style={this.styles.img}>
                      <img
                        width="105"
                        src={urlBase.loopBack+'Attachments/dental_news/download/'+item.name}
                      />
                    </div>
                      )
                    }
                  </div>
                </a>

                <div style={this.styles.contentImgFooter}>
                  <p style={this.styles.contentImgFooterP}>
                    {item.name.split('.')[0]}

                    <span>
                    {
                      localStorage.getItem('dental_y') == 'ADMIN' ? (
                      <i
                        style={this.styles.contentImgFooterIconDel}
                        className="far fa-trash-alt"
                        onClick={this.handleModalDeleteOpen.bind(this, item.name)}
                      >
                        &nbsp;
                      </i>
                      ) : (
                      <a target="_blank" href={urlBase.loopBack+'Attachments/dental_news/download/'+item.name}>
                        <i
                          style={this.styles.contentImgFooterIconDow}
                          className="fas fa-download"
                        >
                          &nbsp;
                        </i>
                      </a>
                      )
                    }
                    </span>
                  </p>
                  
                </div>
              </div>
            </Paper>
          </Grid>
              )}
        </Grid>
              )
            )
          )
        }

        <Dialog
          title={
            <div>
              Confirmação
              <img
                style={this.styles.closeBtn}
                src={urlBase.client+'/assets/images/icons/icon_close.png'}
                onClick={this.handleModalDeleteClose.bind(this)}
              />
            </div>
          }
          titleStyle={{textAlign:'center'}}
          bodyStyle={{padding: '0 12px 24px'}}
          modal={true}
          open={this.state.modalDeleteOpen}
          onRequestClose={this.handleModalDeleteClose.bind(this)}
          actions={
            [
              <FlatButton
                key={0}
                label="Não"
                primary={true}
                disabled={this.state.modalDelete}
                onTouchTap={this.handleModalDeleteClose.bind(this)}
              />,
              <FlatButton
                key={1}
                label="Sim"
                primary={true}
                disabled={this.state.modalDelete}
                onTouchTap={this.sendDelete.bind(this)}
              />
            ]
          }
        >
          {
            this.state.modalDeleteLoading == true ? (
          <div style={{textAlign: 'center'}}>
            <CircularProgress />
          </div>
            ) : ('Tem certeza que deseja excluir este arquivo?')
          }
        </Dialog>

        {
          localStorage.getItem('dental_y') == 'ADMIN' ? (
        <div style={{bottom: 10, position: 'fixed', right: 20}}>
          <FloatingActionButton
            onClick={this.addFile.bind(this)}
          >
            <ContentAdd />
          </FloatingActionButton>
        </div>
          ) : ('')
        }


        <Dialog
          title={
            <div>
              Novo Arquivo
              <img
                style={this.styles.closeBtn}
                src={urlBase.client+'/assets/images/icons/icon_close.png'}
                onClick={this.handleModalClose.bind(this)}
              />
            </div>
          }
          titleStyle={{textAlign:'center'}}
          bodyStyle={{padding: '0 12px 24px'}}
          modal={true}
          open={this.state.modalOpen}
          onRequestClose={this.handleModalClose.bind(this)}
          actions={
            [
              <FlatButton
                key={0}
                label="Fechar"
                primary={true}
                disabled={this.state.btnDisableSaveFile1}
                onTouchTap={this.handleModalClose.bind(this)}
              />,
              <FlatButton
                key={1}
                label="Salvar"
                primary={true}
                disabled={this.state.btnDisableSaveFile2}
                onTouchTap={this.saveFile.bind(this)}
              />
            ]
          }
        >
          {
            this.state.modalSaveLoading == true ? (
          <div style={{textAlign: 'center'}}>
            <CircularProgress />
          </div>
            ) : (
          <Grid container spacing={24}>
            <Grid item xs={12} sm={12} md={4} lg={4}>{''}</Grid>
            <Grid item xs={12} sm={12} md={4} lg={4} style={{textAlign: 'center'}}>
              <label htmlFor="doc_upload" style={{cursor:'pointer'}}>
                <br /><br />
                <img
                  id="name_file_upload"
                  src={urlBase.client+'/assets/images/icons/scan.png'}
                  width="85"
                />
                <i
                  id="name_file_pdf_upload"
                  style={{display: "none"}}
                  className="far fa-file-pdf fa-6x"
                >
                  &nbsp;
                </i>
              </label>
              <input
                id="doc_upload"
                style={{visibility:"hidden",position:'absolute',left: -9999}}
                type="file"
                name="upload"
                onChange={this.fileChange.bind(this, 'upload')}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>{''}</Grid>
          </Grid>
            )
          }
        </Dialog>        
      </div>
    );

  }

}

export default DentalNews;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/DentalNews/DentalNews.js
 **/